import { render, staticRenderFns } from "./InvitationProcurement.vue?vue&type=template&id=6de29670&scoped=true"
import script from "./InvitationProcurement.vue?vue&type=script&lang=js"
export * from "./InvitationProcurement.vue?vue&type=script&lang=js"
import style0 from "./InvitationProcurement.vue?vue&type=style&index=0&id=6de29670&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de29670",
  null
  
)

export default component.exports